function fnLookingGlass(i, oSection) {
	oSection = $(oSection)

	let oInputs = $('.form-block input[type="text"]', oSection),
		oHelpPopupBlock = $('.help-popup-block', oSection),
		oGoButton = $('.go-button', oSection),
		sActionUrl = oSection.attr('data-action')

	oInputs.on('focusin', function () {
		$(this).parents('.item').addClass('on-active')
	})

	oInputs.on('focusout', function () {
		if (!$(this).val()) {
			$(this).parents('.item').removeClass('on-active')
		}
	})

	$('select[name="query"]', oSection).on('change', function () {
		let formData = new FormData();
		formData.append('doc', $(this).val());
		formData.append('dontlook', '');

		fetch(sActionUrl, {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			body: formData
		}).then((response) => {
			return response.json();
		})
		.then((data) => {
			$('.command-reminder', oHelpPopupBlock).html(data.command)
			$('.description', oHelpPopupBlock).html(data.description)
			$('.parameter-desc', oHelpPopupBlock).html(data.parameter)
		});
	})

	$('.help-button', oSection).on('click', () => {
		oHelpPopupBlock.find('.wrap').css('top', window.locoScroll.scroll.instance.delta.y + $('header.primary').outerHeight() + 30)
		oHelpPopupBlock.fadeIn()
	})

	oHelpPopupBlock.on('click', '.close, .overlay', () => {
		oHelpPopupBlock.fadeOut()
	})

	oGoButton.on('click', () => {
		if(oGoButton.hasClass('loading')) return false
		
		oGoButton.addClass('loading')

		let formData = new FormData();
		formData.append('routers', $('[name="routers"]' ,oSection).val());
		formData.append('query', $('[name="query"]' ,oSection).val());
		formData.append('parameter', $('[name="parameter"]' ,oSection).val());
		formData.append('dontlook', '')

		fetch(sActionUrl, {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			body: formData
		}).then((response) => {
			console.log(response);
			return response.json();
		})
		.then((data) => {
			if(typeof data.result !== 'undefined') {
				$('.result-block .output', oSection).html(data.result)
			} else if(typeof data.error !== 'undefined') {
				$('.result-block .output', oSection).html('<p><kbd>'+data.error+'</kbd></p>')
			}

			let tl = gsap.timeline({
				onComplete: () => {
					oGoButton.removeClass('loading')
				}
			})

			tl.to($('.go-button-block', oSection), 1, {
				opacity: 0
			}, 0)
	
			tl.fromTo($('.result-block', oSection), 1, {
				opacity: 0
			}, {
				opacity: 1,
				onStart: () => {
					$('.result-block', oSection).show()
				}
			}, 1)
	
			tl.to($('.actions-block', oSection), 1, {
				height: $('.result-block', oSection).outerHeight()
			}, 1)
		});
	})

	$('.reset-button', oSection).on('click', () => {
		let tl = gsap.timeline()

		tl.fromTo($('.result-block', oSection), 1, {
			opacity: 1
		}, {
			opacity: 0,
			onComplete: () => {
				$('.result-block', oSection).hide()
			}
		}, 0)

		tl.to($('.actions-block', oSection), 1, {
			height: $('.go-button-block', oSection).outerHeight()
		}, 0)

		tl.to($('.go-button-block', oSection), 1, {
			opacity: 1
		}, 1)
	})

}